export default "__VITE_PUBLIC_ASSET__fe801f4b__"